
import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    border: '1px solid #DDD'
  },
  dark:{
    background: '#DDD',
  },
  item: {
    padding: 5,
    textAlign: 'center',
    [theme.breakpoints.only('md')]: {
      padding: 0,
    },
  }
}));

function TwoTone({renderLeft, renderRight}) {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={6} className={classes.item}>
        { renderLeft }
      </Grid>
      <Grid item xs={12} md={6} className={clsx(classes.item, classes.dark)}>
        { renderRight }
      </Grid>
    </Grid>
  )
}

export default TwoTone;
